import React from "react";
import { Button, DropdownButton } from "../Button";

import { Loading } from "../Loader";
import icons from "../../constants/icons";
import { CardHeader } from "../Header";
import { connect } from "react-redux";
import language from "../../language";
import { Checkbox } from "../Input";
import { fetchProductTypes } from "../../utils/queries/productsType";

let copyData = [];

class ProductFilter extends React.Component {
  state = {
    isLoading: true,
    data: [],
    page: 1,
    limit: 100,
    filter_products: [],
  };

  componentDidMount = async () => {
    await this.getData(true);
  };

  componentDidUpdate = async (prevProps) => {
    if (prevProps.categoryType !== this.props.categoryType) {
      await this.getData(true);
    }
  };

  getData = async (isLoading) => {
    try {
      const { defaultLanguage } = this.props;

      this.setState({ isLoading });

      const data = await fetchProductTypes(defaultLanguage, {
        inputType: "dropdown",
      });
      this.setState({
        data: data,
        isLoading: false,
      });

      copyData = data.slice(0);
    } catch (error) {
      this.setState({
        isLoading: false,
      });
    }
  };

  onCheck = async (el) => {
    let { products = [] } = this.state;

    const index = products.findIndex((sEl) => sEl.value === el._id);

    if (index === -1) {
      products.push({
        value: el._id,
        label: el.name,
      });
    } else {
      products.splice(index, 1);
    }
    this.setState({ products });

    this.props.handleApplyFilters &&
      this.props.handleApplyFilters(true, { productTypes: products });
  };

  handleSearch(e) {
    const searchValue = e?.target?.value;
    this.setState({ searchValue });

    let results = [];
    copyData.forEach((el) => {
      if (
        JSON.stringify(el).toLowerCase().indexOf(searchValue.toLowerCase()) !==
        -1
      ) {
        results.push(el);
      }
    });

    this.setState({ data: results });
  }

  onReset() {
    this.setState({ products: [] });
    this.props.handleApplyFilters &&
      this.props.handleApplyFilters(true, { products: [] });
  }

  render() {
    return (
      <DropdownButton
        leftIcon={icons.center}
        text={language[this.props.defaultLanguage].filter_products}
        className="btn-transparent btn-bordered w-sm-100 btn-sm"
        selectedData={this.state?.products}
        clickOutside
      >
        <CardHeader
          title={language[this.props.defaultLanguage].filter_products}
          borderBottom
          closeButton
          isSearch
          handleSearch={this.handleSearch.bind(this)}
        />
        <div className="card-body">
          <Button
            text={language[this.props.defaultLanguage].reset}
            onPress={this.onReset.bind(this)}
          />
        </div>
        <div className="dropdown-content">
          {this.state.isLoading ? (
            <center>
              <Loading />
            </center>
          ) : (
            this.state?.data?.map((el, i) => {
              return (
                <Checkbox
                  label={el.name}
                  key={i}
                  onCheck={() => this.onCheck(el)}
                  checked={this.state?.products?.find(
                    (sEl) => sEl._id === el._id
                  )}
                />
              );
            })
          )}
        </div>
      </DropdownButton>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(ProductFilter);
